exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".element_count[data-v-1d8f33d7] {\n  width: 60px;\n  display: inline-block;\n  padding: 0 10px;\n}\n", ""]);

// exports
